import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PingTracker from 'bundles/degree-description/components/shared/PingTracker';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatagsCms from 'bundles/seo/components/CourseraMetatagsCms';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';
import DegreePage from 'bundles/xddp/components/DegreePage';
import LandingPage from 'bundles/xddp/components/LandingPage';

import 'css!../styl/index';

type Props = {
  children?: JSX.Element;
  requestCountryCode?: string;
  csrfToken?: string;
};

class DegreeApp extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof DegreeApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;
    return { csrfToken, requestCountryCode };
  }

  getPageFromRoute = () => {
    const { children } = this.props;
    const { router } = this.context;
    const currentPageRoute = router.routes[router.routes.length - 1];

    switch (currentPageRoute.name) {
      case 'landing':
        return <LandingPage />;

      default:
        return <DegreePage>{children}</DegreePage>; // Degree404 already has header and footer - this renders 2 headers and 2 footers for 404
    }
  };

  render() {
    return (
      <div className="rc-DegreeApp">
        <CourseraMetatagsCms isDegreePage />
        <PingTracker />
        <DefaultHeader showMetaNav isPositionStatic />
        <UniversalPageFeatures />
        {this.getPageFromRoute()}
        <PageFooter />
      </div>
    );
  }
}

export default compose<Props, Omit<Props, 'csrfToken'>>(
  connectToStores<Props, Omit<Props, 'csrfToken'>>(['ApplicationStore'], ({ ApplicationStore }) => ({
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  })),
  withMarketingConsent
)(DegreeApp);
